import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDeviantartComponent } from './simple-icons-deviantart.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDeviantartComponent ],
    exports:      [ SimpleIconsDeviantartComponent ],
    bootstrap:    []
})
export class SimpleIconsDeviantartModule {}
